import { render, staticRenderFns } from "./Valvulas.vue?vue&type=template&id=2ce65910&scoped=true&"
import script from "./Valvulas.vue?vue&type=script&lang=js&"
export * from "./Valvulas.vue?vue&type=script&lang=js&"
import style0 from "./Valvulas.vue?vue&type=style&index=0&id=2ce65910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce65910",
  null
  
)

export default component.exports